import dayjs from 'dayjs';

const addHours = (date: Date | string, hours: number): string =>
  dayjs(date).add(hours, 'hour').toISOString();

export { addHours };
